import { readFile } from "fs/promises";
import "path";
import { a as arrangebyplayer, g as getGoals, b as getGameInfo, c as getPlayed, d as getBenched, e as getPassAccuracy, f as getPasses, h as getLostBalls, i as getRedCards, j as getShots, k as getShotsOnTarget, l as getTackles, m as getYellowCards, n as getFouls } from "../../../../chunks/arrange.js";
const statsFilePath = "src/_games-stat.json";
const prerender = false;
const playersPath = "src/_players.json";
const players = JSON.parse(await readFile(playersPath, "utf8"));
var data2 = (
  // JSON.parse(await readFile(statsFilePath, "utf8")) ??
  // fetchNew
  //   ? await (
  //       await fetch(
  //         "https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games.json?orderBy=%22firststart%22&startAt=%222023%22"
  //       )
  //     ).json()
  //   :
  JSON.parse(await readFile(statsFilePath, "utf8"))
);
async function load({ fetch, params }) {
  const player = players[params.id];
  const data = arrangebyplayer(
    data2,
    [
      "events",
      "events",
      "incidents",
      "home_lineup",
      "away_lineup",
      "home_substitutes",
      "away_substitutes",
      "goals",
      "offsides",
      "yellowcards",
      "redcards",
      "fouls"
    ],
    Object.values({
      events: "to",
      events2: "from",
      incidents: "playerId",
      home_lineup: "id",
      away_lineup: "id",
      home_substitutes: "id",
      away_substitutes: "id",
      goals: "goal_scorer",
      offsides: "offside_player",
      yellowcards: "yellowcard_player",
      redcards: "redcard_player",
      fouls: "foul_scorer"
      // events: "from",
    }),
    true,
    player?.teamid,
    params.id
  );
  return {
    player,
    // data: data[params.id],
    gamestats: {
      goals: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getGoals)
      ),
      gameinfo: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getGameInfo)
      ),
      played: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getPlayed)
      ),
      benched: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getBenched)
      ),
      passaccuracy: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getPassAccuracy)
      ),
      passes: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getPasses)
      ),
      lostballs: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getLostBalls)
      ),
      redcards: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getRedCards)
      ),
      shots: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getShots)
      ),
      shotsontarget: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getShotsOnTarget)
      ),
      tackles: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getTackles)
      ),
      yellowcards: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getYellowCards)
      ),
      fouls: Object.fromEntries(
        Object.entries(data[params.id] ?? {}).map(getFouls)
      )
      // getPassAccuracy,
      // getPasses,
      // getRedCards,
      // getShots,
      // getShotsOnTarget,
      // getTackles,
      // getYellowCards,
      // getGoals,
      // getFouls,
    }
  };
}
export {
  load,
  prerender
};
